import React from 'react';
import styled from 'styled-components';
import { useLocation, Switch, Route } from 'react-router-dom';
import ViewCampaignAnalyticsProgrammatic from './ViewCampaignAnalyticsProgrammatic';
import ViewCampaignAnalyticsGoogle from './ViewCampaignAnalyticsGoogle';
import ViewCompareAnalytics from './ViewCompareAnalytics';
const AccountContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
`;

const ConnectedAnalytics = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const campaignId = query.get('campaignId');
    const campaignType = query.get('campaignType');
    const campaign1Id = query.get('campaign1Id');
    const campaign2Id = query.get('campaign2Id');
    const campaign3Id = query.get('campaign3Id');
    const campaign4Id = query.get('campaign4Id');
    const campaign5Id = query.get('campaign5Id');

    const campaign1TypeId = query.get('campaign1TypeId');
    const campaign2TypeId = query.get('campaign2TypeId');
    const campaign3TypeId = query.get('campaign3TypeId');
    const campaign4TypeId = query.get('campaign4TypeId');
    const campaign5TypeId = query.get('campaign5TypeId');

    return (
        <AccountContainer>
            <Switch>
                <Route path="/portal/analytics/viewCampaignAnalytics">
                    {campaignType === 'Programmatic' ? (
                        <ViewCampaignAnalyticsProgrammatic
                            campaignType={campaignType}
                            campaignId={campaignId}
                        />
                    ) : (
                        <ViewCampaignAnalyticsGoogle
                            campaignType={campaignType}
                            campaignId={campaignId}
                        />
                    )}
                </Route>
                <Route path="/portal/analytics/viewCompareAnalytics">
                    <ViewCompareAnalytics
                        campaignType={campaignType}
                        campaign1Id={campaign1Id}
                        campaign2Id={campaign2Id}
                        campaign3Id={campaign3Id}
                        campaign4Id={campaign4Id}
                        campaign5Id={campaign5Id}
                        campaign1TypeId={campaign1TypeId}
                        campaign2TypeId={campaign2TypeId}
                        campaign3TypeId={campaign3TypeId}
                        campaign4TypeId={campaign4TypeId}
                        campaign5TypeId={campaign5TypeId}
                    />
                </Route>
                <Route path="/portal/analytics/viewGlobalAnalytics">
                    <div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                        Future Functionality: Global Analytics
                    </div>
                </Route>
            </Switch>
        </AccountContainer>
    );
};

export default ConnectedAnalytics;
